import React from 'react';

const Page = () => {
    return (
        <div>
            <h2>Internal Page</h2>
            <p>This is a model of an internal page.</p>
        </div>
    );
};

export default Page;
